/**
 * `data-testid`s owned by the public contract-signing page (`/contract?t=`).
 * Keep the string values identical to the e2e contract
 * (`e2e/w2-contract/contract.ts`) — the specs select on these.
 *
 * NOTE: `e2e/w2-phq/contract.ts` reserves the exact id `w2-contract` as a
 * FORBIDDEN marker inside the employee PHQ flow; every id here is namespaced
 * `w2-contract-*` (exact-match lookups never collide) and this page renders
 * only on `/contract`, never inside the `/?t=` employee flow.
 */
export const W2_CONTRACT_TID = {
  loading: 'w2-contract-loading',
  loadError: 'w2-contract-load-error',
  retry: 'w2-contract-retry',

  /** The server-rendered document (contract v2) — sections addressed by their number. */
  document: {
    root: 'w2-contract-document',
    section: (number: number) => `w2-contract-section-${number}`,
    termsVersion: 'w2-contract-terms-version',
  },

  pending: {
    root: 'w2-contract-pending',
    ein: 'w2-contract-ein',
    validity: 'w2-contract-validity',
    company: 'w2-contract-company',
    signerName: 'w2-contract-signer-name',
    signDate: 'w2-contract-sign-date',
    attestation: 'w2-contract-attestation',
    attestationLabel: 'w2-contract-attestation-label',
    signButton: 'w2-contract-sign-button',
    signError: 'w2-contract-sign-error',
  },

  signed: {
    root: 'w2-contract-signed',
    message: 'w2-contract-signed-message',
  },

  expired: { root: 'w2-contract-expired' },
  invalid: { root: 'w2-contract-invalid' },
  /** Fail-closed: the document could not be rendered faithfully, so signing is refused. */
  unsupported: { root: 'w2-contract-unsupported' },
} as const;
